import Vue from 'vue'
import eventApi from '@/api/event.api'

const state = {
  eventsByProject: {},
  eventDetailsById: {}
}


const getters = {
  eventsByProject: (state) => (projectId) => {
    return state.eventsByProject[projectId] || []
  },

  lastEventDate: (state) => (projectId) => {
    const lastEventDate = state.eventsByProject[projectId].length ? new Date(Math.max(...state.eventsByProject[projectId].map(e => new Date(e.start)))) : false
    return lastEventDate
  },

  eventsByProjectLoaded: (state) => (projectId) => {
    return state.eventsByProject[projectId] !== undefined
  },

  eventDetailsById: (state) => (id) => {
    return state.eventDetailsById[id]
  }
}


const actions = {
  async loadEventsByProject ({ commit, rootState }, projectId) {
    const response = await eventApi.getEvents(rootState.tenant.current, projectId)
    commit('SET_EVENTS', { projectId, events: response.data })
  },

  async loadAndUpdateEvent ({ commit, dispatch, rootState }, entityData) {
    const response = await eventApi.getEventById(rootState.tenant.current, entityData.projectId, entityData.entityId)
    commit('UPDATE_EVENT', { projectId: entityData.projectId, event: response.data })
    dispatch('eventLabel/loadEventLabels', null, { root: true })
    return response.data
  },

  async loadEventDetailsById ({ commit, rootState }, { id, projectId }) {
    const response = await eventApi.getEventById(rootState.tenant.current, projectId, id)
    commit('SET_EVENT_DETAILS', response.data)
    return response.data
  },

  async loadRelations ({ commit, rootState }, eventId) {
    const response = await eventApi.getRelations(rootState.tenant.current, eventId)
    return response.data
  },

  async createEvent ({ commit, dispatch, rootState }, event) {
    const projectId = event.projectId
    const response = await eventApi.createEvent(rootState.tenant.current, projectId, event)
    commit('CREATE_EVENT', { projectId, event: response.data })
    dispatch('eventLabel/loadEventLabels', null, { root: true })
  },

  async updateEvent ({ commit, dispatch, rootState }, event) {
    const projectId = event.projectId
    const response = await eventApi.updateEvent(rootState.tenant.current, projectId, event.id, event)
    commit('UPDATE_EVENT', { projectId, event: response.data })
    dispatch('eventLabel/loadEventLabels', null, { root: true })
  },

  async deleteEvent ({ commit, rootState }, { id, projectId }) {
    await eventApi.deleteEvent(rootState.tenant.current, projectId, id)
    commit('DELETE_EVENT', { id, projectId })
  },

  removeLabelFromAllEvents ({ commit }, labelId) {
    const eventDetails = Object.values(state.eventDetailsById)
    for (const event of eventDetails) {
      commit('REMOVE_EVENT_LABEL', { event, labelId })
    }

    for (const projectId in state.eventsByProject) {
      for (const event of state.eventsByProject[projectId]) {
        commit('REMOVE_EVENT_LABEL', { event, labelId })
      }
    }
  }
}


const mutations = {
  SET_EVENTS (state, { projectId, events }) {
    Vue.set(state.eventsByProject, projectId, events)
  },

  SET_EVENT_DETAILS (state, event) {
    Vue.set(state.eventDetailsById, event.id, event)
  },

  CREATE_EVENT (state, { projectId, event }) {
    if (!state.eventsByProject[projectId]) {
      Vue.set(state.eventsByProject, projectId, [event])
    } else {
      state.eventsByProject[projectId].push(event)
    }
  },

  UPDATE_EVENT (state, { projectId, event }) {
    Vue.delete(state.eventDetailsById, event.id)

    const i = state.eventsByProject[projectId]?.findIndex(x => x.id === event.id)
    Vue.set(state.eventsByProject[projectId], i, event)
  },

  DELETE_EVENT (state, { projectId, id }) {
    Vue.delete(state.eventDetailsById, id)

    const i = state.eventsByProject[projectId]?.findIndex(x => x.id === id)
    state.eventsByProject[projectId].splice(i, 1)
  },

  REMOVE_EVENT_LABEL (state, { event, labelId }) {
    const labelIndex = event.labels?.findIndex(x => x === labelId)
    if (labelIndex !== -1) {
      event.labels.splice(labelIndex, 1)
    }
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
